var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('collapsible-list',{staticClass:"navbar-item ",attrs:{"options":_vm.collapsibleListItems,"icon":"account","title":_vm.$t('Cuenta')}})}
var staticRenderFns = []

export { render, staticRenderFns }